import type { IconNames } from '@kandji-inc/nectar-ui';
import { osRequirementToDeviceMap } from '../../library/common';

const iconMap = {
  Apple: 'apple-logo',
  Mac: 'device-mac',
  iPad: 'device-ipad',
  iPhone: 'device-iphone',
  'Apple TV': 'device-apple-tv',
  Vision: 'device-vision',
  Windows: 'windows-logo',
  Android: 'android-logo',
};

export const getDeviceIcon = (
  deviceType: string,
  includeVision: boolean = false,
): IconNames => {
  if (deviceType === 'Vision' && !includeVision) {
    return null;
  }
  return iconMap[deviceType as keyof typeof iconMap];
};

// istanbul ignore next
export const orderDeviceIcons = (icons: string[]) => {
  const order = ['Mac', 'iPhone', 'iPad', 'Apple TV', 'Vision'];
  return icons.sort((a, b) => {
    const aIndex = order.indexOf(
      Object.keys(iconMap).find(
        (key) => iconMap[key as keyof typeof iconMap] === a,
      ) || '',
    );
    const bIndex = order.indexOf(
      Object.keys(iconMap).find(
        (key) => iconMap[key as keyof typeof iconMap] === b,
      ) || '',
    );
    return aIndex - bIndex;
  });
};

export const getDeviceOsRequirement = (
  osRequirements: string[] | undefined,
  deviceType: string,
  includeVision: boolean = false,
) => {
  if (!osRequirements?.length) return null;

  /* istanbul ignore next */
  return osRequirements.find((os) =>
    osRequirementToDeviceMap[deviceType]?.(os, includeVision),
  );
};
